var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuResource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.333 1.667h1.02c.91 0 1.647.737 1.647 1.647v10.039c0 .91-.737 1.647-1.647 1.647H1.647C.737 15 0 14.263 0 13.353V3.313c0-.909.737-1.646 1.647-1.646h1.02",
    transform: "translate(-484 -49) translate(484 49) translate(2 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M8.333 1.333h-1C7.333.597 6.736 0 6 0S4.667.597 4.667 1.333h-1c-.553 0-1 .448-1 1v1h6.666v-1c0-.552-.447-1-1-1zM2.5 5.717L6.933 5.717M2.5 12.917L5.5 12.917M2.5 10.517L6.2 10.517M2.5 8.117L8.667 8.117",
    transform: "translate(-484 -49) translate(484 49) translate(2 .5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuResource);
export default __webpack_public_path__ + "static/media/ico16MenuResource.cbacabdf.svg";
export { ForwardRef as ReactComponent };